import {
	type CardSingleSelect,
	type CardToggleSelection,
	CARD_SINGLE_SELECT,
	CARD_TOGGLE_SELECTION,
	CARD_EMPTY_SELECTION,
	type CardEmptySelection,
	CARD_CLEAR_RELATIVE_CARD,
	type CardClearRelativeCard,
} from '../../../../actions/cards/selection';
import type { ListSelectionRelativeCard } from './types';

const initialState = null;

export type Action =
	| CardToggleSelection
	| CardSingleSelect
	| CardEmptySelection
	| CardClearRelativeCard;

export const listSelectionRelativeCardReducer = (
	state: ListSelectionRelativeCard = initialState,
	action: Action,
) => {
	if (action.type === CARD_SINGLE_SELECT) {
		const { cardId } = action.payload;
		return cardId;
	}

	if (action.type === CARD_TOGGLE_SELECTION) {
		const { cardId } = action.payload;
		return cardId;
	}

	if (action.type === CARD_EMPTY_SELECTION || action.type === CARD_CLEAR_RELATIVE_CARD) {
		return null;
	}
	return state;
};
